import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { UserAccountSummary } from '~domain/model/account/user-account-summary';
import { createSelectors } from '~frontend-common/store/create-selectors';

interface UserStoreState {
  user: UserAccountSummary;
}

interface UserStoreActions {
  setUser: (user: UserAccountSummary) => void;
  getFullName: () => string;
}

const initialState: UserStoreState = {
  user: undefined,
};

export const useUserStore = createSelectors(
  create<UserStoreState & UserStoreActions>()(
    devtools(
      (set, get) => ({
        ...initialState,

        getFullName: () => {
          const user = get().user;
          return user ? `${user.firstName} ${user.lastName}` : '';
        },

        setUser: (user: UserAccountSummary) => set({ user }, false, 'setUser'),
      }),
      { store: 'userStore' },
    ),
  ),
);
